import cx from 'classnames'
import Styles from '../ElementsTab.module.scss'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { track } from '@tldraw/tldraw'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { MediaFile } from 'components/Design/UploadsTab/MediaFile'
import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { insertImage } from 'components/Design/UploadsTab/insertImage'
import { DesignActionType } from 'types'
import { IMediaFile } from 'components/Design/UploadsTab/Types'
import { sanitizeAndUploadIcon } from './svgHelpers'
import { NounProjectDownloadResponse, NounProjectIcon } from './NounProjectResponseType'
import { useCompleteDesignAction } from 'components/Design/utils/useCompleteDesignAction'
import { reportError } from 'utils/error'

interface Props {
  iconsToShow: NounProjectIcon[]
}

export const downloadIcon = async (id: string) => {
  const response = await sendToApi<NounProjectDownloadResponse>(`/noun-project/icons/download?id=${id}`, {
    method: 'GET',
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error('Failed to download icon')
  }

  const icon = response.data
  const svgString: string = window.atob(icon.base64_encoded_file)

  return sanitizeAndUploadIcon(svgString, `${id}.svg`)
}

export const NounProjectGrid = track(
  observer(({ iconsToShow }: Props) => {
    const editor = useEditor()
    const { drawersStore } = useRootStore()
    const completeActionMutation = useCompleteDesignAction()

    return (
      <div className={cx(Styles.groupItems, Styles.dense)}>
        {iconsToShow.map((icon) => (
          <MediaFile
            key={icon.id}
            aria-label="Add this icon to the canvas"
            src={icon.thumbnail_url}
            file={
              {
                id: icon.id,
                source_url: icon.thumbnail_url,
                mime_type: 'image/svg+xml',
                variants: [],
                title: icon.id,
              } as IMediaFile
            }
            payload={{
              special_type: 'noun_project',
              special_payload: {
                id: icon.id,
              },
            }}
            onPress={async () => {
              try {
                const s3Url = await downloadIcon(icon.id)
                insertImage(editor, {
                  id: s3Url,
                  source_url: s3Url,
                  mime_type: 'image/svg+xml',
                  variants: [],
                } as IMediaFile)
                completeActionMutation.mutate({ action: DesignActionType.CoreImage })
                drawersStore.closeDrawer()
              } catch (e) {
                reportError(e, { severity: 'error' })
              }
            }}
          />
        ))}
      </div>
    )
  }),
)
